import { configureStore } from '@reduxjs/toolkit';
import pageLayoutReducer from './pageLayoutSlice';
import doaReducer from './delegationOfAuthoritySlice';
import quotesAndNotificationsReducer from './quotesAndNotificationsSlice';

export const store = configureStore({
	reducer: {
		pageLayout: pageLayoutReducer,
		DoA: doaReducer,
		quotesAndNotifications: quotesAndNotificationsReducer
	},
});
